<template>
        <div class="row mb-3 repeater-row" :class="'repeater-row-'+certificateIndex">
            <div class="col-12 col-lg input-certificate">
                <label class="m-show-lg">Certificaat</label>
                <v-select :options="certificates"
                          v-model="certificate.name"
                          v-if="renderedComponent"
                          :reduce="certificates => certificates.name"
                          label="name"
                          taggable
                          :selectOnTab="true"
                          v-validate="'required'"
                          :name="certificateNameIndex"
                          :class="{ 'is-invalid': errors.has(certificateNameIndex) }"
                          @option:created="addCertificate"
                >
                    <div slot="no-options"></div>
                </v-select>
                <span v-if="errors.first(certificateNameIndex)" class="small text-danger">Dit veld is verplicht.</span>
            </div>
            <div class="col-12 col-lg mb-3">
                <label class="m-show-lg">Behaald bij</label>
                <input type="text"
                       class="form-control"
                       v-model="certificate.achievedAt"
                >
            </div>
            <div class="col-12 col-lg mb-3">
                <label class="m-show-lg">Geldig tot</label>
                <datepicker
                        :value="certificate.validUntil"
                        name="certificate-validUntil"
                        :language="nl"
                        v-model="certificate.validUntil"
                        :fullMonthName="true"
                        format="dd-MM-yyyy"
                        input-class='form-control'
                        :calendar-button="true"
                        :calendar-button-icon="'far fa-calendar-alt'"
                        :clear-button="true"
                        :clear-button-icon="'far fa-times'"
                >
                </datepicker>
            </div>
            <div class="col repeat-row-actions">
                <i v-if="certificateIndex !== 0 && !editing" class="far fa-trash-alt"
                   @click="removeCertificateRow(certificateIndex)"></i>
                <i v-if="editing" class="far fa-trash-alt" @click="removeCertificateRow(certificateIndex)"></i>
            </div>
        </div>
</template>

<script>
    import {nl} from 'vuejs-datepicker/dist/locale'

    export default {
        inject: ['$validator'],
        props: {
            certificates: Array,
            certificate: Object,
            certificateIndex: Number,
            editing: Boolean,
            renderedComponent: Boolean
        },
        data() {
            return {
                nl: nl,
            }
        },
        methods: {
            addCertificate(certificate) {
                certificate.default = false;
                certificate.department = this.$store.getters.getUserData.selectedDepartment;
                this.$store.dispatch('certificates/set', certificate)
            },
            removeCertificateRow(certificateIndex) {
                this.$emit('certificateRemoved', certificateIndex)
            },
        },
        computed: {
            certificateNameIndex() {
                return 'certificateName-' + this.certificateIndex;
            },
        }
    }
</script>